import { useEffect, useState } from "react";
import axios from "axios";
import ArchitectChat from "../components/ArchitectChat";
import { FreeAssessment } from "../components/FreeAssessment";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DONATION_URL = process.env.REACT_APP_DONATION_URL || "https://www.masterteacher33.com/donation";

export default function Funnel() {
  useEffect(() => {
    document.title = "The S.P.A.C.E. Academy Identity Diagnostic — Dr. Will Rogers, Masterteacher33";
  }, []);

  function smoothScroll(e, id) {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  return (
    <div className="space-funnel" data-testid="funnel-root">
      {/* TOPBAR */}
      <div className="topbar" data-testid="topbar">
        Ethiopian Christ Canon Diagnostic System <span>·</span> S.P.A.C.E. Academy <span>·</span> Est. 40 Years
      </div>

      {/* ============================================================
          ASCENSION FUNNEL — TOP-OF-PAGE FLOW (new structure 2026)
          ============================================================ */}

      {/* 0 · S.P.A.C.E. BANNER + ENTREPRENEUR HEADLINE */}
      <section className="space-hero-banner" data-testid="space-hero-banner">
        <div className="space-hero-image-wrap">
          <img
            src="/funnel/space_entrepreneur_banner.jpg"
            alt="S.P.A.C.E. Diagnostic — Five Pillar: Spiritual, Psychological, Authentic, Christ-Conscious, Entrepreneurship"
            className="space-hero-image"
            data-testid="space-hero-image"
          />
        </div>
        <div className="space-hero-headline-wrap">
          <h1 className="space-hero-headline" data-testid="space-hero-headline">
            Who Wants To Become A<br />
            <span className="shh-line-2">Spiritual · Psychological · Authentic</span><br />
            <span className="shh-line-3">Christ-Conscious</span>{" "}
            <span className="shh-line-4">Entrepreneur?</span>
          </h1>
          <a
            href={DONATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="space-hero-cta"
            data-testid="space-hero-cta"
          >
            Reserve My Transformation →
          </a>
        </div>
      </section>

      {/* 1 · HOOK */}
      <section className="hook-section" data-testid="hook-section">
        <div className="container-narrow">
          <p className="hook-quote" data-testid="hook-quote">
            <span className="hook-mark">“</span>
            I help <em>spiritually gifted people</em> who feel lost
            discover <strong>exactly who they are</strong> and
            <strong> what they were born to do.</strong>
            <span className="hook-mark hook-mark-close">”</span>
          </p>
          <p className="hook-attribution">— Dr. Will Rogers · Masterteacher33</p>
          <a
            href="#ladder"
            onClick={(e) => smoothScroll(e, "ladder")}
            className="hook-ascension-cta"
            data-testid="hook-ascension-cta"
          >
            <span className="hook-ascension-eyebrow">The Identity Ascension Path</span>
            <span className="hook-ascension-headline">From Stolen ID To Cosmic Sovereign.</span>
            <span className="hook-ascension-sub">Five tiers. One destination. Walk the ladder at your own depth. →</span>
          </a>
        </div>
      </section>

      {/* 1.5 · 6-MONTH BUNDLE PROTOCOL IMAGE */}
      <section className="bundle-image-section" data-testid="bundle-image-section">
        <div className="container">
          <a
            href="#bundle-section"
            onClick={(e) => smoothScroll(e, "bundle-section")}
            className="bundle-image-link"
            data-testid="bundle-image-link"
          >
            <img
              src="/funnel/six_month_bundle.jpg"
              alt="6-Month S.P.A.C.E. Identity Transformation Protocol — 6 Paths · 1 Purpose · Your Divine Transformation · Diagnostic Test Results, Spiritual, Psychological, Authentic, Christ-Conscious Entrepreneur, Identity Integration"
              className="bundle-image"
              data-testid="bundle-image"
              loading="eager"
            />
          </a>
        </div>
      </section>

      {/* 1.6 · BUNDLE VIDEO — sits directly under the protocol image */}
      <section className="bundle-video-section" data-testid="bundle-video-section">
        <div className="container-narrow">
          <p className="bundle-video-eyebrow">Watch · The 6-Month Protocol Explained</p>
          <div className="video-frame">
            <div className="video-aspect">
              <iframe
                src="https://www.youtube.com/embed/OVqRuacbjRA?rel=0&modestbranding=1"
                title="S.P.A.C.E. Academy — 6-Month Identity Transformation Protocol Walkthrough"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
                data-testid="bundle-video-iframe"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 2 · AUTHOR → ARCHITECT IMAGE (moved up) */}
      <section className="top-banner pages-to-people-banner" data-testid="pages-to-people-banner">
        <div className="container">
          <a
            href="#quiz"
            onClick={(e) => smoothScroll(e, "quiz")}
            className="top-banner-link"
            data-testid="pages-to-people-link"
          >
            <img
              src="/funnel/pages_to_people.jpg"
              alt="Masterteacher33 — From Author to Architect · From Pages to People · Build People Now"
            />
          </a>
        </div>
      </section>

      {/* 2.5 · INTRO VIDEOS — two-up pair */}
      <section className="intro-videos-section" data-testid="intro-videos-section">
        <div className="container-narrow">
          <p className="intro-videos-eyebrow">Watch · From Dr. Will Rogers</p>
          <div className="intro-videos-grid">
            <div className="video-frame" data-testid="intro-video-1-frame">
              <div className="video-aspect">
                <iframe
                  src="https://www.youtube.com/embed/I9zq2W2nDnU?rel=0&modestbranding=1"
                  title="S.P.A.C.E. Academy — Dr. Will Rogers · Part I"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                  allowFullScreen
                  data-testid="intro-video-1-iframe"
                />
              </div>
            </div>
            <div className="video-frame" data-testid="intro-video-2-frame">
              <div className="video-aspect">
                <iframe
                  src="https://www.youtube.com/embed/PGHzAVaHf-U?rel=0&modestbranding=1"
                  title="S.P.A.C.E. Academy — Dr. Will Rogers · Part II"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                  allowFullScreen
                  data-testid="intro-video-2-iframe"
                />
              </div>
            </div>
          </div>

          {/* Pull-quote + third video below the two-up pair */}
          <blockquote className="philosophy-quote" data-testid="philosophy-quote">
            <p className="philosophy-quote-line">
              I don&rsquo;t teach people <span className="pq-strike">WHAT TO THINK</span>;
            </p>
            <p className="philosophy-quote-line philosophy-quote-line-2">
              I teach people <em>how to analyze</em>{" "}
              <span className="pq-gold">WHY THEY THINK THAT.</span>
            </p>
            <cite className="philosophy-quote-cite">— Dr. Will Rogers · Masterteacher33</cite>
          </blockquote>

          <div className="intro-video-3-wrap" data-testid="intro-video-3-frame">
            <div className="video-frame">
              <div className="video-aspect">
                <iframe
                  src="https://www.youtube.com/embed/-JrB27MgCzQ?rel=0&modestbranding=1"
                  title="S.P.A.C.E. Academy — Dr. Will Rogers · Part III"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                  allowFullScreen
                  data-testid="intro-video-3-iframe"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3 · BIG DISCOVERY STATEMENT */}
      <section className="discover-section" data-testid="discover-section">
        <div className="container-narrow">
          <p className="discover-eyebrow">The S.P.A.C.E. Diagnostic Reveals…</p>
          <h2 className="discover-headline" data-testid="discover-headline">
            Discover the <span className="violet-glow">exact</span> Spiritual, Psychological,
            Authentic, Christ-Conscious <span className="gold-glow">Entrepreneurship</span> blueprint
            that is driving your <em>entire life</em>.
          </h2>
        </div>
      </section>

      {/* 4 · FREE QUIZ CTA */}
      <section className="free-quiz-cta" data-testid="free-quiz-cta-section">
        <div className="container-narrow">
          <div className="fq-card">
            <p className="fq-kicker">Step One · Free</p>
            <h3 className="fq-title">Take the Free 60-Question S.P.A.C.E. Assessment</h3>
            <p className="fq-sub">
              Sixty plain questions, twelve per pillar, about fifteen minutes. No charge. Your Identity Map
              across all five pillars, on screen the moment you finish.
            </p>
            <a
              href="#quiz"
              onClick={(e) => smoothScroll(e, "quiz")}
              className="fq-btn"
              data-testid="free-quiz-cta-btn"
            >
              Start The Free Assessment →
            </a>
          </div>
        </div>
      </section>

      {/* 5 · ONE BUY NOW — Bundle Offer */}
      <section className="bundle-section" id="bundle-section" data-testid="bundle-section">
        <div className="container-narrow">
          <p className="bundle-kicker">The Complete Transformation Bundle</p>
          <h2 className="bundle-title" data-testid="bundle-title">
            One Decision. Six Months. <span className="gold-glow">A New You.</span>
          </h2>
          <p className="bundle-sub">
            Every tier you need to walk in your covenant identity — bundled into a single
            one-on-one ascension path with Dr. Rogers.
          </p>

          <div className="bundle-includes">
            <div className="bundle-item">
              <span className="bundle-num">01</span>
              <div>
                <h4>The S.P.A.C.E. Diagnostic Test</h4>
                <p>60-question deep assessment across all five pillars. Personalized 8-page Identity Map PDF.</p>
              </div>
            </div>
            <div className="bundle-item">
              <span className="bundle-num">02</span>
              <div>
                <h4>30-Minute Private Live Reading · All-Inclusive</h4>
                <p>Dr. Rogers meets with you live, reads your diagnostic, and names your polarity — all-inclusive, covering S.P.A.C.E. Identity Engineering and S.P.A.C.E. Identity Transformation.</p>
                <a href="/book-reading" className="bundle-book-link" data-testid="book-your-reading-btn">Book Your Reading →</a>
              </div>
            </div>
            <div className="bundle-item bundle-item-flagship">
              <span className="bundle-num">03</span>
              <div>
                <h4>Masterteacher33 6-Month Identity Transformation</h4>
                <p>One-on-one with Dr. Rogers. A monthly architectural rebuild of every pillar of your identity:</p>
                <ul className="bundle-months">
                  <li><strong>Month 1</strong> — Overall Diagnosis Review</li>
                  <li><strong>Month 2</strong> — New Spiritual ID</li>
                  <li><strong>Month 3</strong> — New Psychological ID</li>
                  <li><strong>Month 4</strong> — New Authentic ID</li>
                  <li><strong>Month 5</strong> — New Christ-Conscious ID</li>
                  <li><strong>Month 6</strong> — New Entrepreneurship ID</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bundle-pricing bundle-pricing-3" data-testid="bundle-pricing">
            <div className="bundle-price-option bundle-price-pif" data-testid="price-option-pif">
              <div className="bp-badge">Best Value</div>
              <div className="bp-label">Pay In Full</div>
              <div className="bp-amount">$5,000</div>
              <div className="bp-save">Save $1,000</div>
              <a
                href={DONATION_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bundle-cta bp-cta"
                data-testid="bundle-cta-pif"
              >
                Reserve My Transformation
              </a>
            </div>

            <div className="bundle-price-option" data-testid="price-option-2pmt">
              <div className="bp-label">Two Payments</div>
              <div className="bp-amount">2 × $3,000</div>
              <div className="bp-save">$3K today · $3K in 30 days</div>
              <a
                href={DONATION_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bundle-cta bp-cta"
                data-testid="bundle-cta-2pmt"
              >
                Reserve My Transformation
              </a>
            </div>

            <div className="bundle-price-option" data-testid="price-option-6pmt">
              <div className="bp-label">Six Monthly Payments</div>
              <div className="bp-amount">6 × $1,250</div>
              <div className="bp-save">$1,250/month for 6 months</div>
              <a
                href={DONATION_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bundle-cta bp-cta"
                data-testid="bundle-cta-6pmt"
              >
                Reserve My Transformation
              </a>
            </div>
          </div>

          <p className="bundle-trust">By invitation · Limited to 12 souls per cohort</p>
        </div>
      </section>

      {/* 6 · INTRO VIDEO */}
      <section className="video-section" data-testid="intro-video-section">
        <div className="container-narrow">
          <p className="video-kicker">Watch · From Dr. Rogers</p>
          <h3 className="video-title">A Personal Invitation</h3>
          <div className="video-frame">
            <div className="video-aspect">
              <iframe
                src="https://www.youtube.com/embed/tMWZ22HjR-Y?rel=0&modestbranding=1"
                title="Dr. Will Rogers — S.P.A.C.E. Academy Introduction"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
                data-testid="intro-video-iframe"
              />
            </div>
          </div>
        </div>
      </section>

      <ReserveBar testId="reserve-bar-after-intro-video" />

      {/* 7 · HOW IT WORKS */}
      <section className="how-section" data-testid="how-section">
        <div className="container-narrow">
          <p className="how-kicker">How The Pathway Works</p>
          <h2 className="how-title">Three Steps · One Transformation</h2>
          <div className="how-grid">
            <div className="how-step">
              <div className="how-step-num">1</div>
              <h4>Watch The Video</h4>
              <p>Hear directly from Dr. Rogers why the S.P.A.C.E. system was built — and who it is for.</p>
            </div>
            <div className="how-step">
              <div className="how-step-num">2</div>
              <h4>Take The Free Assessment</h4>
              <p>Sixty plain questions. About fifteen minutes. Your Identity Map across all five pillars — free.</p>
            </div>
            <div className="how-step how-step-flagship">
              <div className="how-step-num">3</div>
              <h4>Enroll In The 6-Month Transformation</h4>
              <p>One decision. Six months. A complete architectural rebuild of every pillar — Spiritual, Psychological, Authentic, Christ-Conscious, Entrepreneurship.</p>
            </div>
          </div>
        </div>
      </section>

      <ReserveBar testId="reserve-bar-after-how" />

      {/* 8 · WHY TRUST S.P.A.C.E. */}
      <section className="trust-section" data-testid="trust-section">
        <div className="container-narrow">
          <p className="trust-kicker">Why The S.P.A.C.E. System Works</p>
          <h2 className="trust-title">
            This is the <span className="gold-glow">only</span> diagnostic on Earth built from
            <em> the oldest continuous Christian canon</em> — combined with 40 years of
            clinical psychology and lived spiritual architecture.
          </h2>
          <div className="trust-pillars">
            <div className="trust-pillar">
              <div className="trust-pillar-num">40</div>
              <p><strong>Years</strong> of one-on-one identity work with leaders, ministers, executives, and creators on six continents.</p>
            </div>
            <div className="trust-pillar">
              <div className="trust-pillar-num">81</div>
              <p><strong>Books</strong> of the Ethiopian Christ Canon — the only Christian scripture tradition that preserved the inner architecture of identity unbroken for 1,700 years.</p>
            </div>
            <div className="trust-pillar">
              <div className="trust-pillar-num">5</div>
              <p><strong>Pillars</strong> diagnosed simultaneously — Spiritual, Psychological, Authentic, Christ-Conscious, Energy — never one in isolation.</p>
            </div>
          </div>
          <blockquote className="trust-quote">
            “Every other system patches the self you were given. S.P.A.C.E. names the self
            you were <em>born to carry</em>.”
            <cite>— Dr. Will Rogers</cite>
          </blockquote>
        </div>
      </section>

      <ReserveBar testId="reserve-bar-after-trust" />

      {/* 9 · WHY BUY NOW */}
      <section className="urgency-section" data-testid="urgency-section">
        <div className="container-narrow">
          <p className="urg-kicker">A Word On Timing</p>
          <h2 className="urg-title">
            The borrowed ID you've been wearing isn't waiting. <br />
            <span className="gold-glow">Every month you delay, it deepens.</span>
          </h2>
          <p className="urg-body">
            Identity fragmentation is not a static condition. It is a slow
            <strong> compounding spiritual debt</strong>. Each year you operate from a self
            that was never yours, three things happen at once:
          </p>
          <ul className="urg-list">
            <li>
              <strong>Your nervous system</strong> hardens around the borrowed pattern.
              What was once a costume becomes neural cement.
            </li>
            <li>
              <strong>Your spirit</strong> grows quieter — not because it has left you,
              but because you've stopped answering it. Eventually you forget the sound of
              your own divine signal.
            </li>
            <li>
              <strong>Your life</strong> builds infrastructure (relationships, jobs, money,
              homes) around the false self. Each layer is harder to unbuild than the last.
            </li>
          </ul>
          <p className="urg-final">
            The cost of waiting is not measured in dollars.
            <strong> It is measured in years you cannot get back.</strong>
            <br />The right time to be diagnosed is <em>before</em> you build one more
            year on the wrong foundation.
          </p>
          <a
            href={DONATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="urg-cta"
            data-testid="urgency-cta-btn"
          >
            Reserve My Place Now →
          </a>
        </div>
      </section>

      {/* 10 · OUTCOMES + SECOND VIDEO */}
      <section className="outcomes-section" data-testid="outcomes-section">
        <div className="container-narrow">
          <p className="out-kicker">What Your Diagnostic Result Actually Means</p>
          <h2 className="out-title">Your Specific Outcome — By Tier</h2>
          <p className="out-intro">
            The Diagnostic does not guess. It places you with surgical precision on each
            of your five pillars. Here is exactly what your result unlocks:
          </p>
          <div className="out-grid">
            <div className="out-card out-fragmented">
              <h4>Fragmented Tier</h4>
              <p>You leave the 6-month transformation with a <strong>rebuilt foundation</strong> in every pillar that scored fragmented. You will recognize yourself again.</p>
            </div>
            <div className="out-card out-developing">
              <h4>Developing Tier</h4>
              <p>Your scattered glimpses of clarity become <strong>a stable inner architecture</strong>. The voice that was occasional becomes daily.</p>
            </div>
            <div className="out-card out-aligned">
              <h4>Aligned Tier</h4>
              <p>You move from quiet alignment to <strong>visible covenant authority</strong> — others begin describing you as “different” without you trying.</p>
            </div>
            <div className="out-card out-sovereign">
              <h4>Sovereign Tier</h4>
              <p>You enter your <strong>legacy phase</strong>. The transformation refines you into a vessel that can carry, teach, and architect identity for others.</p>
            </div>
          </div>

          <p className="video-kicker" style={{ marginTop: 48 }}>Watch · A Client's Story</p>
          <h3 className="video-title">What This Pathway Actually Produces</h3>
          <div className="video-frame">
            <div className="video-aspect">
              <iframe
                src="https://www.youtube.com/embed/so_j0e-hpGU?rel=0&modestbranding=1"
                title="S.P.A.C.E. Academy — Client Outcome Story"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
                data-testid="outcome-video-iframe"
              />
            </div>
          </div>
        </div>
      </section>

      <ReserveBar testId="reserve-bar-after-outcomes" />

      {/* 11 · WHY S.P.A.C.E. vs THE ALTERNATIVES */}
      <section className="vs-section" data-testid="vs-section">
        <div className="container-narrow">
          <p className="vs-kicker">The Honest Comparison</p>
          <h2 className="vs-title">
            Why <span className="gold-glow">S.P.A.C.E.</span> — Instead of Everything Else
            You've Tried.
          </h2>
          <p className="vs-intro">
            If any of these were going to give you your true ID, they already would have.
            Here is why they cannot — and why this can.
          </p>
          <div className="vs-grid">
            <div className="vs-row">
              <div className="vs-col vs-them"><h4>Therapy</h4><p>Treats symptoms of the false self. Rarely names the self you were born to carry.</p></div>
              <div className="vs-arrow">vs</div>
              <div className="vs-col vs-us"><h4>S.P.A.C.E.</h4><p>Diagnoses the architecture beneath every symptom — not the symptom alone.</p></div>
            </div>
            <div className="vs-row">
              <div className="vs-col vs-them"><h4>Coaching</h4><p>Optimizes the current self — even if the current self is a borrowed costume.</p></div>
              <div className="vs-arrow">vs</div>
              <div className="vs-col vs-us"><h4>S.P.A.C.E.</h4><p>Subtracts the borrowed ID first. Then optimizes the one that was always yours.</p></div>
            </div>
            <div className="vs-row">
              <div className="vs-col vs-them"><h4>Courses</h4><p>One-to-many information. No diagnosis. No personal architect.</p></div>
              <div className="vs-arrow">vs</div>
              <div className="vs-col vs-us"><h4>S.P.A.C.E.</h4><p>One-to-one with Dr. Rogers for six full months. Your blueprint, not a syllabus.</p></div>
            </div>
            <div className="vs-row">
              <div className="vs-col vs-them"><h4>Church</h4><p>Sacred container, but typically without diagnostic precision or psychological architecture.</p></div>
              <div className="vs-arrow">vs</div>
              <div className="vs-col vs-us"><h4>S.P.A.C.E.</h4><p>Rooted in the 81-book Ethiopian Christ Canon AND clinical psychology — both, not either.</p></div>
            </div>
            <div className="vs-row">
              <div className="vs-col vs-them"><h4>Self-Help Books</h4><p>Generic advice for a generic self. Cannot see you. Cannot diagnose you.</p></div>
              <div className="vs-arrow">vs</div>
              <div className="vs-col vs-us"><h4>S.P.A.C.E.</h4><p>Specific. Diagnostic. Personalized. A protocol built only for who you actually are.</p></div>
            </div>
            <div className="vs-row">
              <div className="vs-col vs-them"><h4>AI</h4><p>Predictive text trained on the average. It can mirror you. It cannot name you.</p></div>
              <div className="vs-arrow">vs</div>
              <div className="vs-col vs-us"><h4>S.P.A.C.E.</h4><p>40 years of one-on-one identity work. An architect — not a mirror.</p></div>
            </div>
            <div className="vs-row">
              <div className="vs-col vs-them"><h4>Other Coaches</h4><p>Built on a single framework. Usually their own personality, scaled.</p></div>
              <div className="vs-arrow">vs</div>
              <div className="vs-col vs-us"><h4>S.P.A.C.E.</h4><p>Built on a 1,700-year-old canon, modern psychology, and your specific 5-pillar blueprint.</p></div>
            </div>
          </div>
          <a
            href={DONATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="vs-cta"
            data-testid="vs-cta-btn"
          >
            Choose The Architect Path →
          </a>
        </div>
      </section>

      {/* ============================================================
          EXISTING CONTENT BELOW — kept for depth
          ============================================================ */}

      <ReserveBar testId="reserve-bar-after-vs" variant="emphatic" />

      {/* CINEMATIC BENEFITS BANNER — Six Month Pathway */}
      <section className="benefits-banner" data-testid="benefits-banner">
        <div
          className="benefits-banner-bg"
          aria-hidden="true"
          style={{ backgroundImage: "url('/funnel/mt33_benefits_banner_bg.jpg')" }}
        />
        <div className="benefits-banner-overlay" aria-hidden="true" />
        <div className="benefits-banner-content">
          <p className="benefits-banner-eyebrow">The Complete Pathway</p>
          <h1 className="benefits-banner-title" data-testid="benefits-banner-title">
            Benefits of the <span className="bb-mt33">MT33 Six-Month</span><br />
            S.P.A.C.E. Academy <span className="bb-ethiopian">Ethiopian Christ</span> Diagnostic System
          </h1>

          <ul className="benefits-banner-list" data-testid="benefits-list">
            <li><span className="bb-tier">Free</span> eBook</li>
            <li><span className="bb-tier">Free</span> Diakonia Report</li>
            <li><span className="bb-tier">Free</span> 60-Question S.P.A.C.E. Assessment &amp; Identity Map</li>
            <li><span className="bb-tier">Tier 02</span> Five-Pillar Diagnostic Quiz</li>
            <li><span className="bb-tier">Tier 02</span> Five-Pillar Personalized Results PDF</li>
            <li><span className="bb-tier">Tier 03</span> Five-Pillar 30-Minute Private Live Reading (All-Inclusive)</li>
            <li className="bb-plus">
              <span className="bb-tier bb-tier-emerald">PLUS</span>
              Five (1 per Pillar) <strong>30-Day Step-By-Step</strong> Transformation Plans
            </li>
          </ul>

          <div className="benefits-banner-objectives" data-testid="benefits-objectives">
            <p className="bb-obj-label">Each day delivers four objectives:</p>
            <ol className="bb-obj-list">
              <li><span className="bb-obj-num">1</span><span className="bb-obj-name">Identity Declaration</span><span className="bb-obj-desc">— a sentence-level "I AM" statement</span></li>
              <li><span className="bb-obj-num">2</span><span className="bb-obj-name">Somatic Practice</span><span className="bb-obj-desc">— a body / nervous-system anchor</span></li>
              <li><span className="bb-obj-num">3</span><span className="bb-obj-name">Narrative Practice</span><span className="bb-obj-desc">— writing, reflection, or conversation</span></li>
              <li><span className="bb-obj-num">4</span><span className="bb-obj-name">Activation Step</span><span className="bb-obj-desc">— a small external behavior</span></li>
            </ol>
          </div>

          <a
            href="#quiz"
            onClick={(e) => smoothScroll(e, "quiz")}
            className="benefits-banner-cta"
            data-testid="benefits-banner-cta"
          >
            Begin Your Diagnostic →
          </a>
        </div>
      </section>

      {/* TOP BANNER — Diagnostic Scoreboard */}
      <section className="top-banner" data-testid="top-banner">
        <div className="container">
          <a
            href="#quiz"
            onClick={(e) => smoothScroll(e, "quiz")}
            className="top-banner-link"
            data-testid="top-banner-link"
          >
            <img
              src="/funnel/space_banner_hero.jpg"
              alt="S.P.A.C.E. Academy — What's Your S.P.A.C.E. Diagnostic Score? Spiritual, Psychological, Authentic, Christ-Conscious, Entrepreneurship scoring chart"
            />
          </a>
        </div>
      </section>

      {/* AUTHOR → ARCHITECT — The Shift Manifesto */}
      <section className="shift-section" data-testid="shift-section">
        <div className="container-narrow">
          <div className="shift-kicker">The Shift · MT33 · 2026</div>

          <div className="shift-prelude" data-testid="shift-prelude">
            <p className="shift-prelude-line">
              How Your Self-Identity Determines How High You Fly!
            </p>
            <p className="shift-prelude-cta">
              Get in your <em>new</em> Identity!
            </p>
            <h3 className="shift-prelude-title" data-testid="shift-prelude-title">
              Elevated, Coherent, Ethiopian Christ-Conscious Entrepreneurship
            </h3>
          </div>

          <div className="shift-headline-wrap">
            <span className="shift-from">From <em>Author</em></span>
            <span className="shift-arrow" aria-hidden="true">→</span>
            <span className="shift-to">To <em>Architect</em></span>
          </div>

          <p className="shift-tagline">
            For 40 years I wrote the books. <span className="gold">Now I build the souls.</span>
          </p>
          <p className="shift-signature">— Dr. Will Rogers · MT33</p>

          <div className="shift-divider" aria-hidden="true">✦ ✦ ✦</div>

          <div className="shift-manifesto">
            <h2 className="shift-h2">
              The One Problem S.P.A.C.E. Academy Solves Better Than Anyone In The World:
            </h2>
            <p className="shift-h2-payoff">
              <strong>Your True Core Self.</strong><br />
              Your <span className="violet">Spiritual</span>, <span className="gold">Cosmic</span>, <span className="violet">Heavenly</span> Identity.
            </p>

            <p className="shift-body">
              In a world flooded with mindset coaches and financial gurus, people are drowning
              in a silent crisis of <strong>Ontological Insecurity</strong> — they don't know
              who they are at a molecular, cosmic level. So they keep trying to build a life on
              a foundation of <em>stolen identities</em> — titles, jobs, social expectations,
              trauma labels, religious roles, curated avatars.
            </p>

            <blockquote className="shift-quote">
              "You aren't failing because you lack resources.<br />
              You're failing because you're operating with the <span className="gold">wrong ID card</span>.<br />
              You are trying to manifest a <span className="gold">King's life</span> while carrying
              a <span className="ruby">Peasant's frequency</span>."
            </blockquote>

            <div className="shift-pillars">
              <div className="shift-pillar">
                <div className="shift-pillar-old">Mindset Coaching</div>
                <div className="shift-pillar-arrow">→</div>
                <div className="shift-pillar-new">Identity Architecture</div>
              </div>
              <div className="shift-pillar">
                <div className="shift-pillar-old">"Abundance"</div>
                <div className="shift-pillar-arrow">→</div>
                <div className="shift-pillar-new">True Core Identity</div>
              </div>
              <div className="shift-pillar">
                <div className="shift-pillar-old">Information</div>
                <div className="shift-pillar-arrow">→</div>
                <div className="shift-pillar-new">Blueprint For Existence</div>
              </div>
            </div>

            <p className="shift-body">
              When someone knows their <strong>True Core Identity</strong>, abundance becomes a
              byproduct — not the goal. Sell the identity, and the wealth comes for free.
            </p>

            <div className="shift-finale">
              An <span className="ruby-text">author</span> gives people information to read.<br />
              An <span className="gold-text">architect</span> gives people a blueprint for their existence.
              <div className="shift-finale-stinger">
                People pay authors <span className="ruby-text">$20</span>.<br />
                People pay architects <span className="gold-text">$20,000</span>.
              </div>
            </div>
          </div>
        </div>
      </section>

      <ReserveBar testId="reserve-bar-after-manifesto" />

      {/* HERO */}
      <section className="hero" data-testid="hero">
        <div className="hero-grid">
          <div>
            <div className="hero-kicker">THE WORLD'S FIRST · CHRIST CONSCIOUSNESS DIAGNOSTIC SYSTEM</div>
            <h1>
              Your <span className="violet">ID Card</span> Is <span className="gold">Fake.</span>
            </h1>
            <div className="wrong-jesus-block" data-testid="wrong-jesus-block">
              <div className="wrong-jesus-cover">
                <a
                  href="#ebook"
                  onClick={(e) => smoothScroll(e, "ebook")}
                  data-testid="ebook-cover-link"
                >
                  <img
                    src="/funnel/ethiopian_vs_european_jesus.jpg"
                    alt="Ethiopian Jesus vs European Jesus — Free eBook by Dr. Will Rogers"
                  />
                  <span className="wrong-jesus-cover-badge">Free eBook · Get It Below</span>
                </a>
              </div>
              <div className="wrong-jesus-body">
                <div className="wrong-jesus-headline">Do You Have The Wrong Jesus?</div>
                <div className="wrong-jesus-sub">
                  Ethiopian Jesus <span className="vs">vs</span> European Jesus{" "}
                  <span className="ebook-tag">(free eBook)</span>
                </div>
                <div className="wrong-jesus-tag">
                  The First And Only Ethiopian Christ Diagnostic System
                </div>
              </div>
            </div>
            <p className="hero-sub">
              You are not failing because you lack resources. <br />
              You are failing because you are operating with the wrong ID card — trying to manifest a <em>King's life</em> while
              carrying a <em>Peasant's frequency</em>.
            </p>
            <ul className="hero-bullets">
              <li>
                The world's first <strong>Ethiopian Christ Canon</strong> diagnostic system
              </li>
              <li>
                Rooted in the <strong>oldest continuous Christian canon</strong> on Earth
              </li>
              <li>
                Engineered to reveal your <strong>True Cosmic Identity</strong> at the molecular level
              </li>
            </ul>
            <div className="cta-row">
              <a
                href="#quiz"
                onClick={(e) => smoothScroll(e, "quiz")}
                className="btn-primary"
                data-testid="hero-cta-quiz"
              >
                Take The Free 60-Question Assessment
              </a>
              <a
                href="#diakonia-tier"
                onClick={(e) => smoothScroll(e, "diakonia-tier")}
                className="btn-ghost"
                data-testid="hero-cta-test"
              >
                Skip To The $497 Diakonia Report
              </a>
            </div>
            <p className="hero-trust">No mindset coaches · No financial gurus · One True Core Identity</p>
          </div>
          <div className="hero-img-wrap">
            <img src="/funnel/stolen_vs_true.jpg" alt="Stolen Identity Cards vs. True Cosmic Identity Tablet" />
          </div>
        </div>
      </section>

      {/* INTERRUPT */}
      <section className="interrupt" data-testid="interrupt">
        <div className="container-narrow">
          <h2>
            There is a silent crisis spreading through every brilliant soul — <em>Ontological Insecurity.</em>
          </h2>
          <div className="interrupt-text">
            <p>
              You don't know who you are at a <strong>molecular, cosmic level.</strong>
            </p>
            <p>
              So you keep building a life on a stolen ID — the corporate badge, the religious title, the social-media avatar,
              the diploma, the family role, the trauma label, the mask. Each one is a borrowed name on a borrowed frequency.
            </p>
            <p>
              That is why the affirmations don't stick. Why the abundance never lands. Why your gifts cost you more than they
              pay.
            </p>
            <p>
              <strong>The problem is not your effort. The problem is your ID.</strong>
            </p>
            <p className="signature">— Dr. Will Rogers, Masterteacher33</p>
          </div>
        </div>
      </section>

      {/* FREE EBOOK SECTION — dedicated lead magnet */}
      <EbookSection />

      {/* STOLEN GRID */}
      <section className="stolen" data-testid="stolen">
        <div className="container">
          <div className="section-header">
            <div className="section-kicker">The Seven Fake ID Cards</div>
            <h2 className="section-title">Which One Are You Carrying?</h2>
            <p className="section-sub">
              Each of these is a borrowed identity. None of them is you. All of them are bankrupting your real life.
            </p>
          </div>
          <div className="id-grid">
            {[
              ["The Title", "\"I am my job, my degree, my position.\" When the title leaves, so does the self."],
              ["The Religion", "Doctrine memorized. Covenant never lived. A name on a roll, not a name in the Book."],
              ["The Trauma", "\"I am what happened to me.\" A survivor identity that keeps recruiting fresh wounds."],
              ["The Avatar", "Your social-media self — the curated version. Performed daily. Never met."],
              ["The Mask", "The face you wear at work, at church, at home. A different one for each room."],
              ["The Role", "Provider, fixer, protector, peacemaker. Your assignment to a system that did not draft you."],
              ["The Diagnosis", "The label given to you by a system that could not see your gift behind the symptom."],
            ].map(([t, d]) => (
              <div className="id-card" key={t}>
                <h4>{t}</h4>
                <p>{d}</p>
              </div>
            ))}
          </div>
          <div className="stolen-conclusion">
            <p>
              You have spent decades dressing seven different mannequins. <strong>None of them are you.</strong> The S.P.A.C.E.
              Diagnostic strips them off and shows you the one identity that was always there.
            </p>
          </div>
        </div>
      </section>

      {/* CANON */}
      <section className="canon" data-testid="canon">
        <div className="container">
          <div className="canon-grid">
            <div className="canon-img-wrap">
              <img src="/funnel/ethiopian_christ.jpg" alt="The Ethiopian Christ Canon — Source of the S.P.A.C.E. Diagnostic" />
            </div>
            <div className="canon-body">
              <div className="section-kicker">The Source Canon</div>
              <h2>
                The First <span className="gold">Ethiopian Christ</span> Diagnostic System On Earth.
              </h2>
              <p>
                While the Western world built coaching frameworks on Greek psychology and 19th-century positive thinking, the{" "}
                <strong>Ethiopian Orthodox Tewahedo Canon</strong> — the oldest continuous Christian canon in existence —
                quietly held a complete cosmology of the True Self.
              </p>
              <p>
                S.P.A.C.E. is the first diagnostic system in modern history to translate this canonical Christology into a
                five-pillar identity architecture that any soul, of any tradition, can be measured against.
              </p>
              <ul className="canon-features">
                <li>Drawn from the 81-book Ethiopian Canon, including the Book of Enoch, Jubilees, and Meqabyan</li>
                <li>
                  Christ-Conscious as <em>archetype and architecture</em> — not denomination
                </li>
                <li>Ge'ez covenant-identity language translated into modern diagnostic protocol</li>
                <li>Mapped onto contemporary psychology, neuroscience, and energy science</li>
                <li>Produces a personalized Identity Map — your True Core, in five dimensions</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* HERO POLARITY BANNER — Two Realities */}
      <section className="polarity-banner" data-testid="polarity-banner">
        <img
          src="/funnel/hero_polarity.jpg"
          alt="The Two Realities — Stolen ID frequency on the left, True Cosmic Identity on the right"
        />
        <div className="polarity-overlay">
          <div className="polarity-kicker">The Two Realities</div>
          <div className="polarity-headline">
            One ID Pulls You <span className="ruby">Toward Ruin.</span><br />
            The Other Pulls You <span className="gold">Toward Glory.</span>
          </div>
        </div>
      </section>

      {/* DIAGNOSTIC PILLARS */}
      <section className="diagnostic" data-testid="diagnostic">
        <div className="container">
          <div className="section-header">
            <div className="section-kicker">The Diagnostic Architecture</div>
            <h2 className="section-title">Five Pillars. One True Identity.</h2>
            <p className="section-sub">
              S.P.A.C.E. measures the gap between your operating ID and your covenant ID across five dimensions. We do not fix
              you. We <em>identify</em> you.
            </p>
          </div>
          <div className="pillar-grid">
            {[
              ["S", "Spiritual", "Fragmented → Coherent", "p-1"],
              ["P", "Psychological", "Developing → Sovereign", "p-2"],
              ["A", "Authentic", "Masked → True Self", "p-3"],
              ["C", "Christ", "Separated → Embodied", "p-4"],
              ["E", "Entrepreneurship", "Fragmented → Elevated", "p-5"],
            ].map(([letter, name2, desc, cls]) => (
              <div className={`pillar ${cls}`} key={letter}>
                <div className="pillar-letter">{letter}</div>
                <div className="pillar-name">{name2}</div>
                <div className="pillar-desc">{desc}</div>
              </div>
            ))}
          </div>
          <div className="diagnostic-poster-wrap">
            <img src="/funnel/diagnostic_poster.jpg" alt="S.P.A.C.E. Academy Diagnostic Poster — Five Pillars" />
          </div>
        </div>
      </section>

      {/* FREE 60-QUESTION ASSESSMENT */}
      <section className="quiz" id="quiz" data-testid="quiz-section">
        <div className="container-narrow">
          <div className="section-header">
            <div className="section-kicker">Step One · The Free S.P.A.C.E. Assessment · 60 Questions</div>
            <h2 className="section-title" data-testid="quiz-title">Your Identity Map</h2>
            <p className="section-sub">
              Sixty plain questions, about fifteen minutes, no charge. You will see how God wired you across the five
              pillars of the S.P.A.C.E. framework — and the thirty days that come next.
            </p>
            <p className="fa-disclaimer" data-testid="quiz-disclaimer">
              Sixty questions across the five pillars of Dr. Will Rogers’ S.P.A.C.E. framework, offered free. It is
              coaching and teaching — not therapy, counselling or medical care.
            </p>
          </div>
          <FreeAssessment />
        </div>
      </section>

      {/* LADDER */}
      <section className="ladder" id="ladder" data-testid="ladder">
        <div className="container">
          <div className="section-header">
            <div className="section-kicker">The Identity Ascension Path</div>
            <h2 className="section-title">From Stolen ID To Cosmic Sovereign.</h2>
            <p className="section-sub">Five tiers. One destination. Walk the ladder at your own depth.</p>
          </div>

          <div className="ladder-grid">
            <div className="tier level-1">
              <div className="tier-tag">Tier 01 · Lead Magnet</div>
              <div className="tier-name">The Free S.P.A.C.E. Assessment</div>
              <div className="tier-desc">Sixty questions, twelve per pillar. Your Identity Map across all five pillars. The doorway.</div>
              <div className="tier-price free">FREE</div>
              <div className="tier-terms">About 15 Minutes · No Card Required</div>
              <a
                href="#quiz"
                onClick={(e) => smoothScroll(e, "quiz")}
                className="tier-cta"
                data-testid="tier-1-cta"
              >
                Take The Quiz
              </a>
            </div>

            <div className="tier level-2 highlight" id="diakonia-tier">
              <div className="tier-tag">Tier 02 · Diakonia Report</div>
              <div className="tier-name">Your Personalized Diakonia Report</div>
              <div className="tier-desc">
                A 10-page identity architecture reading — your numerological + destiny archetype, your 5-Pillar
                distortion map, the borrowed identity you were handed and the covenant identity you were designed
                for. Auto-generated, sovereign-voiced, PDF delivered.
              </div>
              <div className="tier-price">$497</div>
              <div className="tier-terms">One-Time · Emailed Within Minutes of Payment</div>
              <a
                href="/intake?tier=diakonia_only"
                className="tier-cta"
                data-testid="tier-diakonia-cta"
              >
                Reserve Your Diakonia Report →
              </a>
            </div>

            <div className="tier level-5" id="full-protocol-tier">
              <div className="tier-tag">Tier 03 · Full Identity Transformation</div>
              <div className="tier-name">Diakonia Report + The Full 6-Month S.P.A.C.E. Protocol</div>
              <div className="tier-desc">
                Everything in the Diakonia Report PLUS the 40-page, day-by-day 6-Month Identity Transformation
                Protocol. One pillar rebuilt per month with daily prompts, weekly milestones, and integration
                rituals.
                <ul className="tier-month-list" data-testid="tier-full-months">
                  <li><strong>Month 1</strong> — Diagnostic Review</li>
                  <li><strong>Month 2</strong> — New Spiritual ID</li>
                  <li><strong>Month 3</strong> — New Psychological ID</li>
                  <li><strong>Month 4</strong> — New Authentic ID</li>
                  <li><strong>Month 5</strong> — New Christ-Conscious ID</li>
                  <li><strong>Month 6</strong> — New Entrepreneurship ID</li>
                </ul>
              </div>
              <div className="tier-price">$5,000</div>
              <div className="tier-terms">One-Time · Both PDFs Auto-Generated After Payment</div>
              <a
                href="/intake?tier=full_protocol"
                className="tier-cta"
                data-testid="tier-full-cta"
              >
                Reserve The Full Transformation →
              </a>
            </div>
          </div>

          <p className="ladder-note">
            You do not have to climb both tiers. Most begin with the free assessment. Many step directly into the $497
            Diakonia. The full 6-Month Protocol is for the ones who are done borrowing an identity.
          </p>
        </div>
      </section>

      <ReserveBar testId="reserve-bar-after-ladder" variant="emphatic" />

      {/* QUALIFY */}
      <section className="qualify" data-testid="qualify">
        <div className="container">
          <div className="section-header">
            <div className="section-kicker">The Filter</div>
            <h2 className="section-title">This Is Not For Everyone.</h2>
            <p className="section-sub">
              The S.P.A.C.E. Academy is reserved for souls ready to stop borrowing identities and start walking in their
              covenant name.
            </p>
          </div>
          <div className="qualify-grid">
            <div className="qualify-col yes">
              <h3>This Is For You If</h3>
              <ul>
                <li>You suspect every "self-help" book is patching a self that was never yours</li>
                <li>You are a leader, creator, minister, or operator with a vision still too big for the ID you carry</li>
                <li>You sense a covenant identity beneath your résumé that the world has not yet seen</li>
                <li>
                  You are ready to be <strong>identified</strong>, not optimized
                </li>
                <li>You hear the words "Ethiopian Christ Canon" and your spirit leans forward</li>
              </ul>
            </div>
            <div className="qualify-col no">
              <h3>Do Not Apply If</h3>
              <ul>
                <li>You are shopping for affirmations or another mindset workbook</li>
                <li>You believe identity is a feeling, not an architecture</li>
                <li>You want a $97 course that replaces inner work with vibes</li>
                <li>You are unwilling to question the seven fake IDs you currently wear</li>
                <li>You are not ready to subtract before you add</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* AUTHORITY */}
      <section className="authority" data-testid="authority">
        <div className="container">
          <div className="section-header">
            <div className="section-kicker">The Architect</div>
            <h2 className="section-title">Dr. Will Rogers · Masterteacher33</h2>
          </div>
          <div className="authority-body">
            <p>
              For 40 years I have done one thing — gathered the spiritual, psychological, and biological data nobody else would
              put in the same room, and revealed the <strong>one identity</strong> the world has been working overtime to keep
              you from seeing.
            </p>
            <p>
              I am a 33/6 Compassion Creative Creator. A Masterteacher. The author of the Diakonia Report, the architect of the
              S.P.A.C.E. Academy Diagnostic, and the first to translate the Ethiopian Christ Canon into a working identity
              diagnostic for the modern soul.
            </p>
            <p>
              I am no longer here to sell the library. I am here to <strong>name you.</strong>
            </p>
          </div>
          <div className="authority-credentials">
            {[
              ["40+", "Years of Research"],
              ["81", "Books in the Canon"],
              ["5", "Pillars of Diagnosis"],
              ["1", "True Core Identity"],
            ].map(([n, l]) => (
              <div className="cred" key={l}>
                <div className="cred-number">{n}</div>
                <div className="cred-label">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOMO GALACTICUS BANNER */}
      <section style={{ padding: 0, background: "var(--ink)" }}>
        <img
          src="/funnel/homo_galacticus_landscape.jpg"
          alt="Homo Galacticus — One New Man"
          style={{ width: "100%", display: "block" }}
        />
      </section>

      {/* FAQ */}
      <section className="faq" data-testid="faq">
        <div className="container-narrow">
          <div className="section-header">
            <div className="section-kicker">Questions Most People Are Afraid To Ask</div>
            <h2 className="section-title">Before You Decide</h2>
          </div>
          <div className="faq-list">
            {[
              {
                q: "Is this religious?",
                a: (
                  <>
                    It is <strong>theologically rooted</strong>, not denominational. The "C" in S.P.A.C.E. is Christ-Centered
                    drawn from the Ethiopian Christ Canon — but here Christ is understood as the archetypal True Self, the
                    covenant identity, the architecture of the I AM. If your spirit is open, you are eligible. We do not require
                    belief. We require honesty.
                  </>
                ),
              },
              {
                q: 'Why "Ethiopian Christ Canon" — why does that matter?',
                a: (
                  <>
                    Because it is the <strong>oldest continuous Christian canon in existence</strong>, preserved unbroken since
                    the first century, containing 81 books — including the Book of Enoch, Jubilees, and Meqabyan — that the
                    Western canon dropped. This is the source material modern Western coaching has been operating without.
                    S.P.A.C.E. brings it back into the diagnostic conversation.
                  </>
                ),
              },
              {
                q: "What is the difference between this and a mindset coach?",
                a: (
                  <>
                    A mindset coach optimizes the self you already know. A therapist processes the self that was wounded. The
                    S.P.A.C.E. Diagnostic <strong>identifies the self you do not yet know exists</strong> — your covenant
                    identity beneath the survival identity. We don't adjust the engine. We reveal which engine is actually yours.
                  </>
                ),
              },
              {
                q: "Why $497 for the Diakonia Report when the assessment is free?",
                a: (
                  <>
                    The free assessment shows <em>where you stand</em> on each pillar. The $497 Diakonia Report reveals the <em>why</em> — a
                    personalized 10-page identity architecture reading anchored in your name, birth data,
                    numerological destiny archetype, and 5-Pillar rebuild sequence. The assessment tells you something is
                    misaligned. The Diakonia Report tells you exactly what to do about it.
                  </>
                ),
              },
              {
                q: "Do I have to buy both tiers?",
                a: (
                  <>
                    <strong>No.</strong> Many souls step in at the $497 Diakonia Report and integrate for years on
                    that reading alone. The $5,000 Full 6-Month Protocol is for the ones who are done borrowing an
                    identity and want the day-by-day covenant blueprint to rebuild every pillar.
                  </>
                ),
              },
              {
                q: "How soon will I get my Diakonia Report?",
                a: (
                  <>
                    Within minutes of confirmed payment, your personalized PDF is architected by the Masterteacher33
                    AI system and emailed to you. If you paid for the Full 6-Month Protocol, both the Diakonia
                    Report and the 40-page Protocol PDF arrive together.
                  </>
                ),
              },
              {
                q: "Refund policy?",
                a: (
                  <>
                    <strong>This work is for the committed.</strong> We do not offer refunds because we do not offer halfway
                    entries. The threshold is the filter. If you are not yet ready to be told your true name, do not pay. Begin
                    with the free assessment.
                  </>
                ),
              },
            ].map((item, i) => (
              <div className="faq-item" key={i}>
                <div className="faq-q">{item.q}</div>
                <div className="faq-a">{item.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ReserveBar testId="reserve-bar-after-faq" variant="emphatic" />

      {/* FINAL CTA */}
      <section className="final" id="book" data-testid="final">
        <div className="container-narrow">
          <h2>
            Stop building a life for a self that <span className="gold">does not exist.</span>
          </h2>
          <p className="final-sub">Take the diagnostic that names you. Walk in the ID that was always yours.</p>
          <a
            href="#quiz"
            onClick={(e) => smoothScroll(e, "quiz")}
            className="btn-primary"
            data-testid="final-cta"
          >
            Start Your Identity Diagnostic
          </a>
          <div className="final-signature">
            In service and in fire,
            <strong>Dr. Will Rogers · Masterteacher33</strong>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer" data-testid="footer">
        <div className="container">
          S.P.A.C.E. Academy™ · The Ethiopian Christ Canon Diagnostic System
          <br />
          Dr. Will Rogers, Masterteacher33 ·{" "}
          <a href="https://www.masterteacher33.com" target="_blank" rel="noopener noreferrer">
            masterteacher33.com
          </a>
          <br />
          Spiritual · Psychological · Authentic · Christ-Conscious · Entrepreneurship
          <br />
          © 2026 MasterTeacher33.com · All rights reserved
          <br />
          <a
            href="/admin"
            className="footer-admin-link"
            data-testid="footer-admin-link"
            aria-label="Admin login"
          >
            <svg
              className="footer-admin-icon"
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            Admin Login
          </a>
        </div>
      </footer>
      <StickyReserveBar />
      <ArchitectChat />
    </div>
  );
}

// =====================================================
// RESERVE CTA — inline bar placed after each major section
// =====================================================
function ReserveBar({ variant = "default", testId }) {
  return (
    <section
      className={`reserve-bar reserve-bar-${variant}`}
      data-testid={testId || "reserve-bar"}
    >
      <div className="container-narrow reserve-bar-inner">
        <p className="reserve-bar-copy">
          Ready to walk in your covenant identity?
        </p>
        <a
          href={DONATION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="reserve-bar-btn"
          data-testid="reserve-bar-cta-btn"
        >
          Reserve My Transformation →
        </a>
      </div>
    </section>
  );
}

// =====================================================
// STICKY RESERVE BAR — slides up after user scrolls past the hero
// Dismissible per session via localStorage
// =====================================================
function StickyReserveBar() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem("space_reserve_dismissed") === "1"; }
    catch { return false; }
  });

  useEffect(() => {
    if (dismissed) return;
    function onScroll() {
      // show after user scrolls past ~70vh
      const quiz = document.getElementById("quiz")?.getBoundingClientRect();
      const inQuiz = quiz && quiz.top < window.innerHeight && quiz.bottom > 0;
      setVisible(!inQuiz && window.scrollY > Math.max(window.innerHeight * 0.7, 500));
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [dismissed]);

  function dismiss() {
    setDismissed(true);
    try { localStorage.setItem("space_reserve_dismissed", "1"); } catch {}
  }

  if (dismissed || !visible) return null;

  return (
    <div className="sticky-reserve" data-testid="sticky-reserve-bar">
      <div className="sticky-reserve-inner">
        <div className="sticky-reserve-copy">
          <span className="sticky-reserve-headline">6-Month Identity Transformation</span>
          <span className="sticky-reserve-price">$5,000 PIF · or 2 × $3,000</span>
        </div>
        <a
          href={DONATION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="sticky-reserve-btn"
          data-testid="sticky-reserve-cta-btn"
        >
          Reserve →
        </a>
        <button
          type="button"
          className="sticky-reserve-close"
          onClick={dismiss}
          aria-label="Dismiss"
          data-testid="sticky-reserve-close"
        >
          ×
        </button>
      </div>
    </div>
  );
}

// =====================================================
// EBOOK SECTION — Dedicated free lead magnet w/ email capture
// =====================================================
function EbookSection() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null); // { download_url, name }
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (!name.trim()) {
      setError("Please enter your first name.");
      return;
    }
    if (!email || !email.includes("@")) {
      setError("Please enter a valid email address.");
      return;
    }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/ebook-request`, {
        name: name.trim(),
        email: email.trim(),
      });
      setSuccess({ download_url: res.data.download_url, name: res.data.name });
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
    setSubmitting(false);
  }

  return (
    <section className="ebook-section" id="ebook" data-testid="ebook-section">
      <div className="container">
        <div className="ebook-grid">
          <div className="ebook-cover-large">
            <img
              src="/funnel/ethiopian_vs_european_jesus.jpg"
              alt="Ethiopian Jesus vs European Jesus — The 5th-Century Schism That Shaped Christology"
              data-testid="ebook-cover-image"
            />
            <div className="ebook-cover-glow" />
          </div>

          <div className="ebook-body">
            <div className="ebook-kicker">Free eBook · By Dr. Will Rogers</div>
            <h2 className="ebook-headline">
              Ethiopian Jesus <span className="vs">vs</span>{" "}
              <span className="gold">European Jesus</span>
            </h2>
            <p className="ebook-subhead">
              The 5th-Century Schism That Shaped Christology — and the Christology your church
              never taught you.
            </p>

            <ul className="ebook-bullets">
              <li>
                Why the <strong>Tewahedo</strong> (Ethiopian) and <strong>Duophysite</strong>{" "}
                (European) traditions diverged at Chalcedon in 451 AD
              </li>
              <li>
                The 81-book Ethiopian Canon — and the books the Western canon{" "}
                <strong>quietly dropped</strong>
              </li>
              <li>
                How this single schism shaped every modern identity crisis you didn't know you were
                carrying
              </li>
              <li>The Ethiopian Christ Canon as the source of the S.P.A.C.E. Diagnostic</li>
            </ul>

            {success ? (
              <div className="ebook-success" data-testid="ebook-success">
                <div className="ebook-success-badge">eBook Delivered</div>
                <h3>Your eBook is on its way, {success.name}.</h3>
                <p>
                  We just emailed a download link to your inbox. You can also download it
                  immediately below — and check your inbox for a copy.
                </p>
                <a
                  href={success.download_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                  data-testid="ebook-download-btn"
                >
                  Download The eBook (PDF)
                </a>
                <p className="ebook-note">
                  No inbox? Check spam — or use the direct link above. PDF · ~10 MB
                </p>

                <div className="ebook-pivot" data-testid="ebook-pivot">
                  <div className="ebook-pivot-divider">
                    <span>Already Read It? Take The Next Step</span>
                  </div>
                  <p className="ebook-pivot-text">
                    The eBook tells the <em>story</em>. The free S.P.A.C.E. Assessment tells you which of
                    your five pillars is operating on the <em>wrong</em> Jesus. Sixty questions. About
                    fifteen minutes. Free.
                  </p>
                  <a
                    href="#quiz"
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.getElementById("quiz");
                      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                    }}
                    className="btn-ghost ebook-pivot-cta"
                    data-testid="ebook-pivot-cta"
                  >
                    Take The Free Assessment
                  </a>
                </div>
              </div>
            ) : (
              <form className="ebook-form" onSubmit={handleSubmit} data-testid="ebook-form">
                <input
                  type="text"
                  className="quiz-input"
                  placeholder="Your first name"
                  autoComplete="given-name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  data-testid="ebook-name-input"
                />
                <input
                  type="email"
                  className="quiz-input"
                  placeholder="Your email address"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="ebook-email-input"
                />
                <button
                  type="submit"
                  className="btn-primary"
                  style={{ width: "100%" }}
                  disabled={submitting}
                  data-testid="ebook-submit-btn"
                >
                  {submitting ? "Sending..." : "Send Me The Free eBook"}
                </button>
                {error && (
                  <p style={{ color: "#ff6b5b", marginTop: 10 }} data-testid="ebook-error">
                    {error}
                  </p>
                )}
                <p className="ebook-note">
                  Instant PDF delivery to your inbox. No spam. Unsubscribe anytime.
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
